import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import API from '../../../utils/API';
import LoadingWizard from '../../../components/spinner/wizard';
import logo from '../../../assets/img/logos/simple events logo.png';
import InputField from '../../../components/inputs/inputField';
import ShareableEmailModule from '../../../components/views/ShareableEmailModule';

const ENV =
    process.env.NODE_ENV === 'production'
        ? window.location.href.includes('planner.simple.events') ? `https://admin-api.simple.events/` : `https://beta-api.simple.events/`
        : `http://${window.location.hostname}:5015/`;
class EventSharedEmail extends Component {
    constructor(props) {
        super(props);
        const emailId = props.match.params.email;
        const eventId = props.match.params.event;
        const orgId = props.match.params.organization;
        let authentication = localStorage.getItem('authentication');
        authentication = authentication ? JSON.parse(authentication) : {};
        const valid = authentication.expiry && new Date(authentication.expiry) > Date.now();
        this.state = {
            email: {},
            event: {
                attendees: [],
                sessions: [],
                groups: [],
                emails: [],
                texts: [],
                forms: [],
                pages: [],
                submissions: [],
            },
            expired: !valid,
            encryptedCode: '',
            email: '',
            fullName: '',
            authenticatedUser: {
                email: '',
                fullName: '',
                _id: ''
            },
            error: '',
            emailError: '',
            fullNameError: '',
            emailCode: '',
            codeError: '',
            emailId,
            orgId,
            eventId,
            loading: true,
            codeRequested: false,
            feedbackThreads: [],
        };
    }

    async componentDidMount() {
        const { emailId, eventId, orgId, expired } = this.state;

        // Load stored user data from localStorage
        const storedUserData = localStorage.getItem('authenticatedUser');
        if (storedUserData) {
            try {
                const userData = JSON.parse(storedUserData);
                this.setState({
                    authenticatedUser: userData,
                    email: userData.email,
                    fullName: userData.fullName
                });
            } catch (e) {
                console.log('Error parsing stored user data:', e);
            }
        }

        if (!expired) {
            await this.loadEmail();
        }
    }

    verifyEmail = async () => {
        const { email, fullName, emailId, orgId } = this.state;

        // Check if email and fullName are required and defined
        let emailError = '';
        let fullNameError = '';

        if (!email) {
            emailError = 'Email is required';
        }
        if (!fullName) {
            fullNameError = 'Full name is required';
        }

        if (emailError || fullNameError) {
            this.setState({ emailError, fullNameError });
            return;
        }

        try {
            const res = await API().post(`Organizations/${orgId}/platformActions/eventEmailAccess/${emailId}`, { requestorEmail: email.toLowerCase(), requestorFullName: fullName });
            if (res.data) {
                let sharedUser = res.data.sharedUser;
                this.setState({ codeRequested: true, emailError: '', fullNameError: '', encryptedCode: res.data.ec, authenticatedUser: sharedUser });
            }
        } catch (e) {
            this.setState({ emailError: 'Access Denied', fullNameError: '' });
        }
    }

    submitCode = async () => {
        const { emailCode, email, fullName } = this.state;
        try {
            const validCode = this.validateCode(emailCode);
            if (validCode) {
                localStorage.setItem('authentication', JSON.stringify({ expiry: new Date(Date.now() + 1000 * 60 * 60 * 24 * 7) }));

                // Store user data in localStorage
                const userData = { ...this.state.authenticatedUser };
                localStorage.setItem('authenticatedUser', JSON.stringify(userData));

                this.setState({
                    expired: false,
                    error: '',
                    codeError: '',
                    authenticatedUser: userData
                }, this.loadEmail);
            } else {
                this.setState({ codeError: 'Invalid Code', error: '' });
            }
        } catch (e) {
            console.log(e)
            this.setState({ error: 'Access Denied' });
        }
    }

    loadEmail = async () => {
        const { emailId, eventId, orgId } = this.state;
        try {
            const res = await API().get(`Organizations/${orgId}/events/${eventId}/shareableEmail/${emailId}/`);
            if (res.data) {
                const email = res.data.email;
                const feedbackThreads = res.data.feedbackThreads || [];
                const sharedWith = res.data?.email?.sharedWith || [];

                this.setState({ email: email, loading: false, feedbackThreads: feedbackThreads });
            }
        } catch (e) {
            console.log(e);
        }
    }

    validateCode = (code) => {
        const key = this.state.emailId.toString();
        const encryptedCode = this.state.encryptedCode;
        let decrypted = [...encryptedCode].map((char, index) => {
            const shift = key.charCodeAt(index % key.length);
            return String.fromCharCode(char.charCodeAt(0) - shift);
        }).join('');
        return decrypted === code;
    }

    closeReport = () => {
        localStorage.removeItem('authentication');
        localStorage.removeItem('authenticatedUser');
        window.location.reload();
    }

    /* Ill be housing all feedback related functions here */


    addNewThread = async (newThread, callback) => {
        const { email, emailId, eventId, orgId } = this.state;
        const payload = {
            ...newThread
        };

        try {
            const res = await API().post(`Organizations/${orgId}/events/${eventId}/shareableEmail/${emailId}/post-thread`, payload);
            if (res.data) {
                const savedThread = res?.data.thread;
                const feedbackThreads = [...this.state.feedbackThreads, savedThread];
                this.setState({ email: email, loading: false, feedbackThreads: feedbackThreads }, () => {
                    if (callback) {
                        callback();
                    }
                });
            }
        } catch (e) {
            console.log(e);
        }

    }

    patchThread = async (threadId, updatedThread, callback) => {
        const { email, emailId, eventId, orgId } = this.state;
        const payload = {
            ...updatedThread
        };

        try {
            const res = await API().patch(`Organizations/${orgId}/events/${eventId}/shareableEmail/${emailId}/thread/${threadId}`, payload);
            if (res.data) {
                const updatedThread = res?.data.thread;
                let feedbackThreads;

                if (payload?.deleted === true) {
                    feedbackThreads = this.state.feedbackThreads.filter(thread => thread._id !== threadId);
                } else {
                    feedbackThreads = this.state.feedbackThreads.map(thread => {
                        if (thread._id === updatedThread._id) {
                            return updatedThread;
                        }
                        return thread;
                    });
                }

                this.setState({ email: email, loading: false, feedbackThreads: feedbackThreads }, () => {
                    if (callback) {
                        callback();
                    }
                });
            }
        } catch (e) {
            console.log(e);
        }

    }


    render() {
        const {
            email,
            event,
            eventId,
            orgId,
            loading,
            expired,
            codeRequested,
            authenticatedUser
        } = this.state;


        return (
            <Fragment>       
                {!loading && <div className='pageContainer' style={{ height: 'calc(100% - 51px)' }}>
                    <ShareableEmailModule

                        isOpen={true}
                        emailTemplate={email}
                        orgId={orgId}
                        eventId={eventId}
                        keyedMetadata={[]}
                        keyedData={{}}
                        event={{}}
                        branding={event.branding}
                        url={`${ENV}Organizations/${orgId}/emailrenderer`}
                        method={{}}
                        postData={{}}
                        toggle={() => { }}
                        update={this.updateCampaignHtml}
                        cancelEdit={this.cancelEdit}
                        links={{
                            getAssets: `Organizations/${orgId}/events/${eventId}/assets`,
                            addAssets: `Organizations/${orgId}/events/${eventId}/assets`,
                        }}
                        authenticatedUser={authenticatedUser}
                        addNewThread={this.addNewThread}
                        feedbackThreads={this.state.feedbackThreads}
                        patchThread={this.patchThread}
                        closeReport={this.closeReport}
                    />
                </div>}

                <LoadingWizard loading={loading && !expired} text="Loading Email" />
                {expired && <div className="flex column aic jcc h-100">
                    <div className='flex column inputCard'>

                        <h1 className='mb-10'>Event Campaign</h1>
                        <p className='mb-20'>{!codeRequested ? 'Please enter your email address to view this Campaign.' : 'A code was sent to the email entered, enter it below to view this Campaign.'}</p>
                        <InputField
                            label={'Full Name'}
                            type={'text'}
                            value={this.state.fullName}
                            classes={`mb-20 ${codeRequested ? 'gray' : ''}`}
                            disabled={codeRequested}
                            onChange={(e) => this.setState({ fullName: e.target.value })}
                            placeholder={'Enter your full name'}
                            inputIcon={codeRequested ? <i className='la las-lock' /> : null}
                            errorTrigger={this.state.fullNameError !== ''}
                            errorMessage={this.state.fullNameError}
                            required={true}
                            
                        />
                        <InputField
                            label={'Email'}
                            type={'email'}
                            value={this.state.email}
                            classes={`mb-20 ${codeRequested ? 'gray' : ''}`}
                            disabled={codeRequested}
                            onChange={(e) => this.setState({ email: e.target.value })}
                            placeholder={'Enter email'}
                            inputIcon={codeRequested ? <i className='la las-lock' /> : null}
                            errorTrigger={this.state.emailError !== ''}
                            errorMessage={this.state.emailError}
                            required={true}
                        />
                        {codeRequested && <InputField
                            label={'Code'}
                            type={'text'}
                            value={this.state.emailCode}
                            classes="mb-20"
                            onChange={(e) => this.setState({ emailCode: e.target.value })}
                            placeholder={'Enter code recieved in email'}
                            errorTrigger={this.state.codeError !== ''}
                            errorMessage={this.state.codeError}
                        />}
                        <button className="ml-a neu prim" onClick={() => !codeRequested ? this.verifyEmail() : this.submitCode()}>
                            Continue
                        </button>
                    </div>
                </div>}
            </Fragment>
        );
    }
}

export default withRouter(EventSharedEmail);
